export default function getTimeStatusColor({
  value,
  mode,
  threshold = 1,
  alertOnExceed = true,
}) {
  if (mode === 'elapsed') {
    return alertOnExceed ? value > threshold : value < threshold;
  }

  if (mode === 'remaining') {
    return alertOnExceed ? value <= threshold : value > threshold;
  }

  return false;
}
